/**
 * UI elements
 */
class MM_UI {
    constructor() {
        this.initFocusForms();
        this.initAutocompleteSearchOff();
        this.initTextAccordion();
        this.initAgeementsAccordion();
        this.initBackLinksInCategories();
        this.initCustomInputNumber();
        this.initAddPlaceholders();
        this.initWrapCheckbox();
        this.initShowFVInput();
        this.initOpenSidebar();
        this.initHideDeliveryIcon();
        this.iniExpandDescription();
        this.initClosePromoPopup();
        this.initOpenTooltip();

        $(document).ready(() => {
            this.initSmoothScroll();
        });
    }

    initFocusForms () {
        var inputs = document.querySelectorAll('.has-focus');

        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];

            input.addEventListener('focus', function() {
                this.classList.add('is-active');
            });

            input.addEventListener('blur', function() {
                if (this.value === '') {
                    this.classList.remove('is-active');
                }
            });
        }
    }

    initSmoothScroll () {
        $('a[href*="#"]').not('[href^="#tab-"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 60
                    }, 1000);
                }
            }
        });
    }

    initAutocompleteSearchOff() {
        let inputSearch = $('.search-field');

        if (inputSearch.length) {
            inputSearch.attr('autocomplete', 'off');
        }
    }

    initTextAccordion () {
        $(".composition-block").each(function(i, item) {
            $(item).find('.text-wrapper').css('height', 0);
            $(item).removeClass('not-initialized');

            $(item).on("click", function () {
                var item = $(this);
                var contentWrapper = item.find('.text-wrapper');
                var contentText = item.find('.text-wrapper p');

                item.toggleClass('active');
                var newHeight = contentText.outerHeight();

                if (item.hasClass('active')) {
                    contentWrapper.css('height', 0);

                    setTimeout(function() {
                        contentWrapper.css('height', newHeight + 'px');
                    }, 0);

                    setTimeout(function() {
                        contentWrapper.css('height', 'auto');
                    }, 500);
                } else {
                    contentWrapper.css('height', newHeight + 'px');

                    setTimeout(function() {
                        contentWrapper.css('height', 0);
                    }, 0);
                }
            });
        });
    }

    initAgeementsAccordion () {
        $('.more-info-wrapper').each(function(i, item) {
            $(item).find('.more-info').css('height', 0);
            $(item).removeClass('not-initialized');

            $(item).on("click", function (e) {
                e.preventDefault();
                var item = $(this);
                var contentWrapper = item.find('.more-info');
                var contentText = item.find('.more-info p');
                item.toggleClass('active');
                var newHeight = contentText.outerHeight();
                if (item.hasClass('active')) {
                    contentWrapper.css('height', 0);
                    contentWrapper.css('opacity', 0);

                    setTimeout(function() {
                        contentWrapper.css('height', newHeight + 'px');
                        contentWrapper.css('opacity', 1);
                    }, 0);

                    setTimeout(function() {
                        contentWrapper.css('height', 'auto');
                        contentWrapper.css('opacity', 1);
                    }, 500);
                } else {
                    contentWrapper.css('height', newHeight + 'px');
                    contentWrapper.css('opacity', 1);

                    setTimeout(function() {
                        contentWrapper.css('height', 0);
                        contentWrapper.css('opacity', 0);
                    }, 0);
                }
            });
        });
    }

    initBackLinksInCategories () {
        let basicUrl = $(document.body).attr('data-shop-url');
        let widgetWrapper = $('.shop-sidebar .product-categories');

        if (widgetWrapper.length) {
            let currentCatLink = widgetWrapper.find('.current-cat');

            if (currentCatLink.length && currentCatLink.find('a').length) {
                let goBackLink = $('<a class="go-back-link">&times;</a>');
                goBackLink.attr('href', basicUrl);
                currentCatLink.find('a').eq(0).after(goBackLink);
            }
        }
    }

    initCustomInputNumber () {
        let quantityWrapper = $('.woocommerce');
        let quantity = quantityWrapper.find('.quantity');

        quantity.append($('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>'));

        $('.quantity').each(function() {
            let spinner = $(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.quantity-up'),
            btnDown = spinner.find('.quantity-down'),
            min = input.attr('min'),
            max = input.attr('max');
    
            btnUp.click(function() {
                let oldValue = parseFloat(input.val());
                let newVal = oldValue + 1;

                if (max > 0 && oldValue >= max) {
                    newVal = oldValue;
                } 

                input.val(newVal);
                input.trigger("change");
            });
    
            btnDown.click(function() {
                let oldValue = parseFloat(input.val());
                let newVal = oldValue - 1;

                if (oldValue <= min) {
                    newVal = oldValue;
                }

                input.val(newVal);
                input.trigger("change");
            });
        });

        $( document.body ).on( 'updated_cart_totals', function(){
            let quantityWrapper = $('.woocommerce');
            let quantity = quantityWrapper.find('.quantity');
            quantity.append($('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>'));

            $('.quantity').each(function() {
                let spinner = $(this),
                input = spinner.find('input[type="number"]'),
                btnUp = spinner.find('.quantity-up'),
                btnDown = spinner.find('.quantity-down'),
                min = input.attr('min'),
                max = input.attr('max');
        
                btnUp.click(function() {
                    let oldValue = parseFloat(input.val());
                    let newVal = oldValue + 1;
    
                    if (max > 0 && oldValue >= max) {
                        newVal = oldValue;
                    } 
    
                    input.val(newVal);
                    input.trigger("change");
                });
        
                btnDown.click(function() {
                    let oldValue = parseFloat(input.val());
                    let newVal = oldValue - 1;
    
                    if (oldValue <= min) {
                        newVal = oldValue;
                    }
    
                    input.val(newVal);
                    input.trigger("change");
                });
            });
        });
    }

    initAddPlaceholders () {
        let inputs = $('.input-text');
        let inputName = $('input[name="account_first_name"]');
        let inputLastname = $('input[name="account_last_name"]');
        let inputPasCurrent = $('input[name="password_current"]');
        let inputPasNew = $('input[name="password_1"]');
        let inputPasNew2 = $('input[name="password_2"]');
        let loginWrapper = $('#customer_login .login');
        let regWrapper = $('#customer_login .register');
        let loginUser = loginWrapper.find('input[name="username"]');
        let loginPass = loginWrapper.find('input[name="password"]');
        let regEmail = regWrapper.find('input[name="email"]');
        let regPass = regWrapper.find('input[name="password"]');
        let wooCheckout = $('body.woocommerce-checkout');
        let wooCheckoutLogin = wooCheckout.find('.woocommerce-form-login');
        let wooCheckoutLoginUser = wooCheckoutLogin.find('input[name="username"]');
        let wooCheckoutLoginPass = wooCheckoutLogin.find('input[name="password"]');
        let wooCheckoutCompany = wooCheckout.find('input[name="billing_company"]');
        let wooCheckoutShipName = wooCheckout.find('input[name="shipping_first_name"]');
        let wooCheckoutShipLastname = wooCheckout.find('input[name="shipping_last_name"]');
        let wooCheckoutShipCompany = wooCheckout.find('input[name="shipping_company"]');

        for (let i = 0; i < inputs.length; i++) {
            var input = inputs.eq(i);
            var inputLabel = input.parent().parent().find('label').text();
            var inputPlaceholder = input.attr('placeholder');

            if( inputPlaceholder === undefined || inputPlaceholder === '') {
                input.attr('placeholder', inputLabel);
            }
        }

        inputPasCurrent.attr('placeholder', 'Aktualne hasło (pozostaw puste, aby nie zmieniać)');
        inputPasNew.attr('placeholder', 'Nowe hasło');
        inputPasNew2.attr('placeholder', 'Potwierdź hasło');
        inputName.attr('placeholder', 'Imię*');
        inputLastname.attr('placeholder', 'Nazwisko*');
        loginUser.attr('placeholder', 'Adres e-mail');
        loginPass.attr('placeholder', 'Hasło');
        regEmail.attr('placeholder', 'Adres e-mail');
        regPass.attr('placeholder', 'Hasło');
        wooCheckoutLoginUser.attr('placeholder', 'Użytkownik lub e-mail');
        wooCheckoutLoginPass.attr('placeholder', 'Hasło');
        wooCheckoutCompany.attr('placeholder', 'Nazwa firmy');
        wooCheckoutShipName.attr('placeholder', 'Imię');
        wooCheckoutShipLastname.attr('placeholder', 'Nazwisko');
        wooCheckoutShipCompany.attr('placeholder', 'Nazwa firmy');
    }

    initWrapCheckbox () {
        var checkboxWrapper = $('.checkout');
        var checkboxInput = checkboxWrapper.find('input[type="checkbox"]');

        if (checkboxInput.length) {
            checkboxInput.parent().addClass('checkbox-wrapper');
        }
    }

    initShowFVInput() {
        let fvCheckboxWrapper = $('.fv-checkbox-wrapper');
        let fvCheckboxWrapperLabel = fvCheckboxWrapper.children('label');
        let fvCheckboxWrapperNIP = fvCheckboxWrapper.find('.nip-input');
        let input = fvCheckboxWrapper.find('.input-checkbox');
        input.css('pointer-events', 'none');

        fvCheckboxWrapperLabel.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            input.prop('checked', !input.prop('checked'));
            fvCheckboxWrapperNIP.toggleClass('is-active');

            let optionValue = input.prop('checked') ? 'Chcę otrzymać fakturę VAT' : 'Bez faktury VAT';

            dataLayer.push({     
                'event': 'checkoutOption', 
                'ecommerce': { 
                    'checkout_option': { 
                        'actionField': {
                            'step': 2, 
                            'option': optionValue
                        } 
                    }
                } 
            }); 
        });
    }

    initOpenSidebar () {
        var openFilters = $('.open-filters');
        var sidebar = $('.shop-sidebar')

        if (openFilters.length) {
            openFilters.on('click', e => {
                e.preventDefault();
                sidebar.toggleClass('is-active');
            });
        }
    }

    initHideDeliveryIcon () {
        if (!$('body').hasClass('single-product')) {
            return;
        }

        let variationRadios = $('.woovr-variation-radio');
        let benefits = $('.footer-benefits-block.short .benefits-list .benefit')

        if (variationRadios.length && benefits.length) {
            let imageToToggle = benefits.eq(0);
            let checkedInput = $('.woovr-variation-radio input:checked');

            if (checkedInput.parents('.woovr-variation-radio').attr('data-purchasable') === 'no') {
                imageToToggle.addClass('is-hidden');
            }
            
            variationRadios.each((i, radio) => {
                $(radio).on('click', () => {
                    if ($(radio).attr('data-purchasable') === 'no') {
                        imageToToggle.addClass('is-hidden');
                    } else {
                        imageToToggle.removeClass('is-hidden');
                    }
                });
            });
        }
    }

    iniExpandDescription() {
        let readMoreBtn = $('.archive-description-read-more');
        let longDescription = $('#custom-archive-description-long');

        if (readMoreBtn.length) {
            readMoreBtn.on('click', function () {
                longDescription.toggleClass('hide-element');
                longDescription.toggleClass('open-element');
            });   
        }
    }

    initClosePromoPopup () {
        let popups = $('.ss-promo-offer-popup');
  
        for (let i = 0; i < popups.length; i++) {
            let closeBtn = popups.eq(i).find('.close');
            let popup = popups.eq(i);
            let popupInner = popups.eq(i).find('.popup-inner');
  
            $( document.body ).on('click', () => {
                popup.addClass('is-hidden');
            });
    
            closeBtn.on('click', (e) => {
                e.preventDefault();
                popup.addClass('is-hidden');
            });
    
            popupInner.on('click', (e) => {
                e.stopPropagation();
            });
        }
    }

    initOpenTooltip () {
        let tooltipsBlock = $('.has-tooltip');
      
        if (!tooltipsBlock.length) {
          return
        }
    
        for (let i = 0; i < tooltipsBlock.length; i++) {
            tooltipsBlock.eq(i).on('click', e => {
                e.preventDefault();
                console.log(e.target);
                let tooltipIsActive = $(e.target).hasClass('is-active');
                tooltipsBlock.removeClass('is-active');
                
                if (!tooltipIsActive) {
                    $(e.target).addClass('is-active');
                }
            });
        }
    }
}